import { ApiService } from './api.service';

export * from './api-schema-validations';

export const apiService = new ApiService();
